<template>
	<div class="base">
		<slot/>
	</div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>
.base {

}
</style>
